import React, { useEffect, useState } from 'react';
import {
	DiversityType,
	passwordStrength,
	Result,
} from 'check-password-strength';
import {
	MAX_PASSWORD_LENGTH,
	MIN_PASSWORD_LENGTH,
} from '../../../utils/constants';

import classNames from './strength.module.scss';

interface PasswordStrengthProps {
	password: string;
}

const PasswordStrength: React.FC<PasswordStrengthProps> = ({ password }) => {
	const [result, setResult] = useState(initialResult);

	const calculateActualScore = (): number => {
		const maxScore: number = 3;
		const actualScore: number = result.id / maxScore;

		const scoreInPercentage: number = actualScore * 100;
		return scoreInPercentage === 0 ? 10 : scoreInPercentage;
	};

	const getBarStrengthColor = () => {
		const colors: string[] = ['red', 'orange', 'yellow', 'green'];
		const scoreIndex: number = Math.floor(result.id);

		return colors[scoreIndex];
	};

	useEffect(() => {
		const strengthResult = passwordStrength(password);
		setResult(strengthResult);
	}, [password]);

	return (
		<React.Fragment>
			<div className={classNames.passwordStrength}>
				<div
					className={classNames.passwordStrengthBar}
					style={{
						width: calculateActualScore() + '%',
						backgroundColor: getBarStrengthColor(),
						borderColor: getBarStrengthColor(),
					}}
				></div>
			</div>

			<ul className={classNames.passwordStrengthGuides}>
				<li
					className={
						result.length < MIN_PASSWORD_LENGTH ||
						result.length > MAX_PASSWORD_LENGTH
							? classNames.invalid
							: classNames.valid
					}
				>
					Character length must be at least {MIN_PASSWORD_LENGTH} and less than{' '}
					{MAX_PASSWORD_LENGTH}
				</li>

				{rules.map((rule) => {
					const isSuffixRequired = ['lowercase', 'uppercase'].includes(rule);

					return (
						<li
							className={
								result.contains.includes(rule)
									? classNames.valid
									: classNames.invalid
							}
							key={rule}
						>
							Must contain at least 1 {rule}{' '}
							{isSuffixRequired ? 'character' : ''}
						</li>
					);
				})}
			</ul>
		</React.Fragment>
	);
};

const rules: DiversityType[] = ['lowercase', 'uppercase', 'number', 'symbol'];

const initialResult: Result<string> = {
	contains: [],
	id: 0,
	length: 0,
	value: 'Too weak',
};

export default PasswordStrength;
